// Module
var code = "<template class=\"au-animate animation-fade-in-short\"> <require from=\"./busy-indicator.scss\"></require> <div class=\"busy-indicator-inner\"> <icon class=\"busy-indicator\" name=\"busy-indicator\"></icon> <slot></slot> </div> </template> ";
// Exports
module.exports = code;